"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MempoolClient = exports.REGTEST_MEMPOOL_BASE_PATH = exports.TESTNET_MEMPOOL_BASE_PATH = exports.MAINNET_MEMPOOL_BASE_PATH = void 0;
exports.MAINNET_MEMPOOL_BASE_PATH = 'https://mempool.space/api/v1';
exports.TESTNET_MEMPOOL_BASE_PATH = 'https://mempool.space/testnet4/api/v1';
exports.REGTEST_MEMPOOL_BASE_PATH = 'http://localhost:3003';
class MempoolClient {
    constructor(networkOrUrl = 'mainnet') {
        switch (networkOrUrl) {
            case 'mainnet':
                this.basePath = exports.MAINNET_MEMPOOL_BASE_PATH;
                break;
            case 'testnet':
                this.basePath = exports.TESTNET_MEMPOOL_BASE_PATH;
                break;
            case 'regtest':
                this.basePath = exports.REGTEST_MEMPOOL_BASE_PATH;
                break;
            default:
                this.basePath = networkOrUrl;
        }
    }
    async getRecommendedFees() {
        return this.getJson(`${this.basePath}/fees/recommended`);
    }
    async getJson(url) {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(response.statusText);
        }
        return (await response.json());
    }
}
exports.MempoolClient = MempoolClient;
